var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [{ name: "ripple", rawName: "v-ripple" }],
      class: { selected: _vm.showSelected },
      attrs: { id: "ticketList" }
    },
    [
      [
        _c("vo-avatar", {
          staticClass: "avatar",
          attrs: { user: _vm.user, size: 32 }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "left" }, [
          _c("div", { staticClass: "name" }, [
            _vm._v(_vm._s(_vm.user.fullName || "Full Name Goes Here"))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "email" }, [
            _vm._v(_vm._s(_vm.user.email || "email@goeshere.com"))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "right" }, [
          _c("div", { staticClass: "status" }, [
            _vm._v(_vm._s(_vm.user.joined > 0 ? "JOINED" : "INVITED"))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "date" }, [
            _vm._v(
              _vm._s(
                _vm._f("dateShorthand")(
                  _vm.user.joined > 0 ? _vm.user.joined : _vm.user.created
                )
              )
            )
          ])
        ])
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07f63906", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07f63906","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PeopleList.vue
// module id = 536
// module chunks = 4